import React from 'react';
import Footer from '../components/Footer';
import StartBanner from '../components/start/StartBanner.js';
import Navbar from '../components/navbar/Navbar.js';
import EnergyhouseWidget from '../components/EnergyhouseWidget.js';
import { useSEO } from '../components/CustomHook';

// Banderole
import Scroller from '../components/Scroller.js';
import aiko from "../images/logos/aiko.svg";
import ecoflow from "../images/logos/ecoflow.jpeg";
import kfw from "../images/logos/kfw.jpeg";
import panasonic from "../images/logos/panasonic.jpeg";
import sigenergy from "../images/logos/sigenergy.jpeg";
import trina from "../images/logos/trina.svg";

// Import the images
import pic1 from '../images/start/pic_1.svg';
import pic2 from '../images/start/pic_2.png';
import pic3 from '../images/start/pic_3.jpeg';
import pic4 from '../images/start/pic_4.jpg';
import pic5 from '../images/start/pic_5.jpg';
import pic6 from '../images/start/pic_6.webp';
import pic7 from '../images/start/pic_7.jpg';
import pic10 from '../images/start/pic_10.webp';

const logos = [
    { src: aiko, alt: "Aiko" },
    { src: ecoflow, alt: "EcoFlow" },
    { src: kfw, alt: "KfW" },
    { src: panasonic, alt: "Panasonic" },
    { src: sigenergy, alt: "Sigenergy" },
    { src: trina, alt: "Trina" },
    { src: aiko, alt: "Aiko" },
    { src: ecoflow, alt: "EcoFlow" },
    { src: kfw, alt: "KfW" },
    { src: panasonic, alt: "Panasonic" },
    { src: sigenergy, alt: "Sigenergy" },
    { src: trina, alt: "Trina" },
    { src: aiko, alt: "Aiko" },
    { src: ecoflow, alt: "EcoFlow" },
    { src: kfw, alt: "KfW" },
    { src: panasonic, alt: "Panasonic" },
    { src: sigenergy, alt: "Sigenergy" },
    { src: trina, alt: "Trina" },
    { src: aiko, alt: "Aiko" },
    { src: ecoflow, alt: "EcoFlow" },
    { src: kfw, alt: "KfW" },
    { src: panasonic, alt: "Panasonic" },
    { src: sigenergy, alt: "Sigenergy" },
    { src: trina, alt: "Trina" },
];



const Start = () => {
    // SEO-Optimierung für die Startseite
    useSEO(
        "Schmid Energieberatung - Experte für erneuerbare Energien, Wärmepumpen & Solaranlagen",
        "Professionelle Energieberatung für Wärmepumpen, Solaranlagen und erneuerbare Energien. Individuelle Beratung, Planung und Installation für Ihre Energiewende.",
        "Energieberatung, Wärmepumpe, Solaranlage, erneuerbare Energien, Photovoltaik, Energiewende, Förderung, Schmid, Energieberater",
        "/logo512.png"
    );

    return (
        <>
            <Navbar />
            <StartBanner />
            <Scroller data-direction="right" data-speed="slow">
                <div className="scroller__inner">
                    {logos.map((logo, index) => (
                    <img
                        key={index}
                        src={logo.src}
                        alt={logo.alt}
                        className="logo-scroller"
                    />
                     ))}
                </div>
            </Scroller>

            {/* Savings Calculator Section - Without Button */}
            <section className="py-10 px-4 sm:px-6 lg:px-8 bg-gray-50">
                <div className="max-w-4xl mx-auto text-center">
                    <h2 className="text-2xl md:text-3xl font-semibold text-primary mb-4">
                        Jetzt Ihre Ersparnis entdecken
                    </h2>
                    <p className="text-lg text-gray-700 mb-6 max-w-2xl mx-auto">
                        Berechnen Sie ganz einfach, wie viel Geld Sie mit einer Solaranlage von Schmid-
                        Energieberatung GmbH sparen können.
                    </p>
                    <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
                        Unser Ersparnisrechner zeigt Ihnen in wenigen Klicks Ihr persönliches Sparpotenzial –
                        transparent, schnell und unverbindlich. Starten Sie jetzt und sehen Sie, wie sich Ihre Investition schon heute bezahlt macht!
                    </p>
                </div>
                <EnergyhouseWidget />
            </section>

            {/* New Generation Energy Solutions Section */}
            <section className="py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-6xl mx-auto">
                    <div className="flex flex-col md:flex-row items-center gap-8">
                        <div className="md:w-1/2">
                            <h2 className="text-2xl md:text-3xl font-bold text-primary mb-6">
                                Die neue Generation von Energielösungen
                            </h2>
                            <h3 className="text-xl font-semibold text-gray-800 mb-4">
                                Maximale Leistung – heute und morgen
                            </h3>
                            <p className="text-gray-700 mb-6">
                                Mit unseren innovativen Stromspeichern,
                                leistungsstarken Solarmodulen und modernen Wallboxen
                                setzen wir neue Standards am deutschen Energiemarkt.
                                Profitieren Sie von zukunftssicherer Technik, die auf
                                höchste Effizienz, Langlebigkeit und Sicherheit
                                ausgelegt ist.
                            </p>
                            <h3 className="text-xl font-semibold text-gray-800 mb-4">
                                Intelligente Vernetzung
                            </h3>
                            <p className="text-gray-700 mb-6">
                                Alle Komponenten – von der Photovoltaikanlage über
                                den Speicher bis hin zur Wärmepumpe – arbeiten nahtlos
                                zusammen und werden smart gesteuert. So schöpfen Sie
                                das volle Potenzial Ihres Energiesystems aus.
                            </p>
                            <h3 className="text-xl font-semibold text-gray-800 mb-4">
                                Mehr Ertrag mit modernster Solartechnik
                            </h3>
                            <p className="text-gray-700 mb-6">
                                Unsere PV-Anlagen liefern bis zu 30 % mehr Leistung
                                – selbst bei schwierigen Bedingungen wie
                                Teilverschattung oder wechselnder Sonneneinstrahlung.
                            </p>
                            <h3 className="text-xl font-semibold text-gray-800 mb-4">
                                Geprüfte Qualität & maximale Sicherheit
                            </h3>
                            <p className="text-gray-700">
                                Dank höchster Sicherheitsstandards und TÜV-
                                zertifizierter Technik investieren Sie in ein System, das
                                nicht nur zuverlässig, sondern auch langfristig geschützt
                                ist.
                            </p>
                        </div>
                        <div className="md:w-1/2 flex justify-center">
                            <div className="w-full flex justify-center bg-gray-100 overflow-hidden h-48 sm:h-96">
                                <img
                                    src={pic1}
                                    alt="Energieberatung"
                                    className="w-full h-full object-cover object-center"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            {/* Products Heading */}
            <section className="py-10 px-4 sm:px-6 lg:px-8">
                <div className="max-w-6xl mx-auto">
                    <h2 className="text-3xl md:text-4xl font-bold text-primary text-center mb-12">
                        Alle Produkte von Schmid Energieberatung GmbH
                    </h2>

                    {/* Products Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {/* Tile 1 - Row 1 & 2, Column 1 */}
                        <div className="md:row-span-2 md:col-span-1 rounded-lg h-64 md:h-auto flex items-center justify-center relative">
                            <img
                                src={pic3}
                                alt="Produkt 1"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute bottom-4 right-4">
                                <a href="/solarmodule" className="bg-white text-primary font-semibold py-2 px-4 rounded-lg shadow-md hover:bg-gray-100 transition-colors duration-200">
                                    Zur Solaranlage
                                </a>
                            </div>
                        </div>

                        {/* Tile 2 - Row 1, Column 2 & 3 */}
                        <div className="md:col-span-2 rounded-lg h-64 flex items-center justify-center relative">
                            <img
                                src={pic2}
                                alt="Produkt 2"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute bottom-4 right-4">
                                <a href="/stromspeicher" className="bg-white text-primary font-semibold py-2 px-4 rounded-lg shadow-md hover:bg-gray-100 transition-colors duration-200">
                                    Zum Stromspeicher
                                </a>
                            </div>
                        </div>

                        {/* Tile 3 - Row 2, Column 2 & 3 */}
                        <div className="md:col-span-2 rounded-lg h-64 flex items-center justify-center relative">
                            <img
                                src={pic4}
                                alt="Produkt 3"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute bottom-4 right-4">
                                <a href="/energiemanagement" className="bg-white text-primary font-semibold py-2 px-4 rounded-lg shadow-md hover:bg-gray-100 transition-colors duration-200">
                                    Zum Managementsystem
                                </a>
                            </div>
                        </div>

                        {/* Tile 4 - Row 3, Column 1 & 2 */}
                        <div className="md:col-span-2 rounded-lg h-64 flex items-center justify-center relative">
                            <img
                                src={pic5}
                                alt="Produkt 4"
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute bottom-4 right-4">
                                <a href="/waermepumpe" className="bg-white text-primary font-semibold py-2 px-4 rounded-lg shadow-md hover:bg-gray-100 transition-colors duration-200">
                                    Zur Wärmepumpe
                                </a>
                            </div>
                        </div>

                        {/* Tile 5 - Row 3, Column 3 */}
                        <div className="rounded-lg h-64 flex items-center justify-center relative">
                            <img
                                src={pic6}
                                alt="Produkt 5"
                                className="w-full h-full object-cover object-right"
                            />
                            <div className="absolute bottom-4 right-4">
                                <a href="/wallbox" className="bg-white text-primary font-semibold py-2 px-4 rounded-lg shadow-md hover:bg-gray-100 transition-colors duration-200">
                                    Zur Wallbox
                                </a>
                            </div>
                        </div>

                        {/* Tile 6 - Row 4, Column 1 & 2 & 3 */}
                        <div className="md:col-span-3 rounded-lg h-64 flex items-center justify-center relative">
                            <img
                                src={pic7}
                                alt="Produkt 6"
                                className="w-full h-full object-cover object-[50%_25%]"
                            />
                            <div className="absolute bottom-4 right-4">
                                <a href="/notstrom" className="bg-white text-primary font-semibold py-2 px-4 rounded-lg shadow-md hover:bg-gray-100 transition-colors duration-200">
                                    Notstrom
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

             {/* New Text Section with Image */}
            <section className="py-12 px-4 sm:px-6 lg:px-8 bg-gray-50">
                <div className="max-w-6xl mx-auto">
                    <div className="flex flex-col md:flex-row items-center gap-8">
                        <div className="md:w-1/2">
                            <h2 className="text-2xl md:text-3xl font-bold text-primary mb-6">
                                Rundum unabhängig – 365 Tage im Jahr
                            </h2>
                            <p className="text-gray-700 mb-4">
                                Mit einer Lösung von Schmid-Energieberatung GmbH sind Sie nicht nur im Sommer versorgt.
                                Unser ganzheitliches Energiesystem kombiniert Solaranlage, Speicher und intelligente Steuerung
                                zu einem starken Gesamtpaket.
                            </p>
                            <p className="text-gray-700 mb-4">
                                Das Ergebnis: verlässliche Energie an jedem Tag des Jahres – selbst dann, wenn die Sonne kaum
                                scheint. Überschüsse werden gespeichert, Bedarfe smart gedeckt, und falls nötig laden Sie zusätzlich
                                günstig aus dem Netz.
                            </p>
                            <p className="text-gray-700 mb-6">
                                So entsteht Ihr persönliches 365-Tage-Energiesystem: effizient, flexibel und zukunftssicher.
                            </p>
                            <a
                                href="/kontakt"
                                className="bg-primary text-white rounded-lg font-semibold text-sm px-4 py-2 lg:px-6 lg:py-3 transition-all duration-200 hover:scale-105 inline-block"
                            >
                                Jetzt beraten lassen!
                            </a>
                        </div>
                        <div className="md:w-1/2 flex justify-center">
                            <div className="w-full h-96 flex items-center justify-center bg-gray-100 overflow-hidden">
                                <img
                                    src={pic10}
                                    alt="365 Tage Energieversorgung"
                                    className="w-full h-full object-cover object-center"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>

    )
}

export default Start;